<template>
  <el-dialog class="el-dialogs" title="修改" width="40%" :close-on-click-modal="false"
             :visible.sync="visible">
    <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules" label-width="100px"
             class="magTop">
      <el-form-item label="排序：" prop="publishSequence">
        <el-input-number v-model="searchForm.publishSequence" controls-position="right"
                         @change="setBorrowDays('publishSequence')"
                         :min="0" label="请输入排序"></el-input-number>
      </el-form-item>
      <el-form-item label="是否显示：" prop="showFlag">
        <el-switch
            v-model="searchForm.showFlag"
            active-value="0"
            inactive-value="1">
        </el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button type="primary" size="small" @click="sureData()" v-no-more-click>确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "modifyPublish",
  data() {
    return {
      visible: false,
      searchForm: {
        publishSequence: 0,
        showFlag: '1',
      },
      rules: {
        publishSequence: [
          {required: true, message: '请输入排序', trigger: 'blur'},
        ],
        showFlag: [
          {required: true, message: '是否显示', trigger: 'change'},
        ],
      },
      maxSort: 0,
    }
  },

  methods: {
    init(selectList) {
      this.visible = true
      this.dataListSelect = selectList
      console.log(this.dataListSelect)
      if (this.dataListSelect.jsonData.shifouxianshitzngusilcu == '开'){
        this.searchForm.showFlag = '0'
      }else {
        this.searchForm.showFlag = '1'
      }
      this.searchForm.publishSequence = this.dataListSelect.jsonData.shunxuhaojpgucqlwxv
      this.getOthers()
    },

    getOthers() {
      this.$axios(this.api.user.configKey + 'publish_sequence').then(data => {
        if (data && data.status) {
          this.maxSort = data.data
        }
      })
    },

    //只能输入大于0的正整数
    setBorrowDays(formName) {
      let setValue = this.searchForm[formName] + ''
      setValue = setValue.replace(/[^0-9]/g, "")
      if (setValue * 1 > this.maxSort) {
        setValue = this.maxSort
      }
      this.$nextTick(() => {
        this.searchForm[formName] = setValue
      })
    },

    sureData() {
      this.$refs['searchForm'].validate((valid) => {
        if (valid) {
          this.$axios(this.api.metadata.batchShowByMetadataId, {
            dataIds: [this.dataListSelect.id],
            ...this.searchForm,
          }, 'post').then(data => {
            if (data.status) {
              this.$message.success('修改成功！')
              this.$emit('refreshData')
              this.visible = false
            } else {
              this.$message.error('修改失败！')
            }
          })
        }
      })
    },
  },
}
</script>

<style scoped>

</style>